import { useMemo } from "react";

import { ModalBody, ModalFooter } from "@transfr-inc/dashboard-components";
import { Button } from "@transfr-inc/dashboard-components/forms";

export const ArchiveClassroomsConfirmSlide = ({
  classrooms = [],
  onCancel,
  onConfirm,
}) => {
  const classroomName = useMemo(() => {
    const count = classrooms?.length;

    if (count === 1) {
      return classrooms[0].name;
    }
    return `${count} classrooms`;
  }, [classrooms]);

  return (
    <>
      <ModalBody>
        Are you sure you would like to archive <strong>{classroomName}</strong>?
        The data for archived classrooms will remain unchanged.
      </ModalBody>
      <ModalFooter>
        <Button onClick={onCancel}>No, Cancel</Button>
        <Button primary onClick={onConfirm}>
          Yes, Archive
        </Button>
      </ModalFooter>
    </>
  );
};
